/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Diffuser } from "./modelDiffuser";

class ControllerDiffuser extends ControllerModel {
    constructor() {
        super("ControllerDiffuser");

        this.setNewNode = (callback) => {
            let diffuser = new Diffuser();
            diffuser.decorate(callback);

            this.addNode(diffuser);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let diffuser = new Diffuser();
            diffuser.copyFrom(node);
            diffuser.decorate(callback);
            this.addNode(diffuser)
        }

        this.getProperties = async (node) => {
            let n = new Diffuser();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Diffuser();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerDiffuser };